import { Ticket, MapPin } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { Eyebrow } from 'shared/components/Eyebrow';
import { Heading } from 'shared/components/Heading';

export interface EventListItemProps {
  date: Date
  title: string;
  location: string;
  type?: 'virtual' | 'in-person';
}

export function EventListItem({
  date,
  title,
  location,
  type = 'virtual',
}: EventListItemProps) {
  const { t } = useTranslation();

  const monthStr = date.toLocaleString('en', { month: 'short' })

  return (
    <li className="group flex items-center justify-between p-8 bg-surface-container-low rounded-3xl hover:bg-surface-container transition-colors">
      <div className="flex gap-8 items-center">
        <div className="text-center min-w-[3rem]">
          <Eyebrow as="p">{monthStr}</Eyebrow>
          <p className="text-3xl font-serif italic text-on-surface">{date.getDay()}</p>
        </div>
        <div>
          <Heading variant="sub" className="mb-1 text-on-surface">{title}</Heading>
          <p className="text-sm text-on-surface-variant">{`${location} \u2022 ${date.getTime()}`}</p>
        </div>
      </div>
      <span className="text-outline-variant group-hover:text-tertiary transition-colors" aria-hidden="true">
        {type === 'in-person' ? <MapPin size={24} /> : <Ticket size={24} />}
      </span>
      <span className="sr-only">{type === 'in-person' ? t('a11y.inPersonEvent') : t('a11y.virtualEvent')}</span>
    </li>
  );
}
